export const enum MyAccountNotesStatechartStateEnum {
  idle = 'idle',
  start = 'start',
  fetchingNotesProperties = 'fetchingNotesProperties',
}
